import Aos from "aos";
import { addDoc, collection } from "firebase/firestore";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/1.png";
import email from "../../assets/images/email.webp";
import locationIcon from "../../assets/images/locationIcon.webp";
import { Col, Container, Row } from "../../components/GridSystem";
import { useContextHook } from "../../Context/ContextOPen";
import { db } from "../../firebase";
import { content } from "../../lang/useLang";
import { ContactList } from "../../Context/Lists";

const ContactUs = ({ phoneNumber }) => {
  const { swiperIndex, direction } = useContextHook();
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    product: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "messages"), formData);
      alert("تم إرسال النموذج بنجاح!");
      setFormData({ name: "", phone: "", email: "", product: "" });
    } catch (error) {
      console.error("حدث خطأ عند الإرسال: ", error);
    }
  };

  useEffect(() => {
    Aos.init();
  }, []);

  return (
    <div
      className="min-h-screen bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-[#334155] relative overflow-hidden"
      style={{ direction }}
    >
      <br />
      <br />
      {/* خلفية متحركة متناسقة مع الموقع */}
      {swiperIndex === 5 && (
        <>
          {/* أشكال هندسية متحركة */}
          <div className="absolute inset-0 overflow-hidden">
            <div className="absolute top-1/4 -left-20 w-80 h-80 bg-slate-600/20 rounded-full blur-3xl animate-float-slow"></div>
            <div className="absolute bottom-1/4 -right-20 w-96 h-96 bg-slate-500/15 rounded-full blur-3xl animate-float-slow animation-delay-3000"></div>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-slate-400/10 rounded-full blur-2xl animate-pulse-soft"></div>
          </div>

          {/* خطوط متقاطعة ديناميكية */}
          <div className="absolute inset-0 opacity-15">
            <div className="absolute top-0 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-slate-400 to-transparent animate-scan-vertical"></div>
            <div
              className="absolute top-1/3 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-slate-300 to-transparent animate-scan-vertical"
              style={{ animationDelay: "2s" }}
            ></div>
            <div
              className="absolute top-2/3 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-slate-500 to-transparent animate-scan-vertical"
              style={{ animationDelay: "4s" }}
            ></div>
          </div>

          {/* جسيمات متحركة بشكل مختلف */}
          <div className="absolute inset-0 opacity-40">
            {[...Array(12)].map((_, i) => (
              <div
                key={i}
                className="absolute w-2 h-2 bg-slate-300 rounded-full animate-drift"
                style={{
                  left: `${Math.random() * 100}%`,
                  top: `${Math.random() * 100}%`,
                  animationDelay: `${Math.random() * 6}s`,
                  animationDuration: `${20 + Math.random() * 15}s`,
                }}
              ></div>
            ))}
          </div>

          {/* شبكة نقاط ديناميكية */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.1)_1px,transparent_1px)] bg-[length:30px_30px] animate-grid-move"></div>
          </div>

          {/* تأثير ضبابي متدرج */}
          <div className="absolute inset-0 bg-gradient-to-b from-slate-900/30 via-transparent to-slate-800/20 backdrop-blur-[2px]"></div>
        </>
      )}

      <Container className="relative z-10 flex items-center">
        <div className="w-full">
          {/* البطاقة الرئيسية */}
          <div
            className={`relative transform transition-all duration-1000 ${
              swiperIndex === 5
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-10"
            }`}
            style={{
              transitionDelay: "500ms",
            }}
          >
            {/* تأثير خلفي للبطاقة */}
            <div className="absolute -inset-3 bg-gradient-to-r from-slate-600 via-slate-500 to-slate-400 rounded-3xl blur opacity-20 group-hover:opacity-30 transition duration-1000 group-hover:duration-200"></div>

            {/* البطاقة الرئيسية */}
            <div className="relative bg-gradient-to-br from-slate-800/90 to-slate-700/90 rounded-3xl overflow-hidden border border-slate-600/30 backdrop-blur-xl shadow-2xl">
              <div className="p-5">
                <Row className="items-start">
                  {/* معلومات الاتصال */}
                  <Col md={6} className="space-y-2">
                    {/* الشعار والعنوان */}
                    <div className="flex items-center gap-4 mb-3">
                      <img src={logo} alt="" className="w-20" />
                      <div className="font-bold text-2xl text-white">
                        {content.prime_pixels_technology}
                      </div>
                    </div>

                    {/* البريد الإلكتروني */}
                    <div className="p-3 bg-slate-700/50 rounded-xl border border-slate-600/50 hover:border-slate-400 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg group">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-gradient-to-r from-slate-600 to-slate-500 rounded-full flex items-center justify-center group-hover:scale-105 transition-transform duration-300 shadow-lg">
                          <img
                            src={email}
                            alt=""
                            className="w-5 h-5 filter brightness-0 invert"
                          />
                        </div>
                        <div className="text-slate-200 font-medium text-sm">
                          {content.email_1}
                        </div>
                      </div>
                    </div>

                    {/* العناوين */}
                    <Row>
                      {["UAE", "Oman", "Egypt", "Jordan"].map((e, i) => (
                        <Col key={i} md={6} className="!p-1">
                          <div className="p-3 h-full bg-slate-700/50 rounded-xl border border-slate-600/50 hover:border-slate-400 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg group">
                            <div className="flex items-start gap-3">
                              <div className="w-10 h-10 bg-gradient-to-r from-slate-600 to-slate-500 rounded-full flex items-center justify-center group-hover:scale-105 transition-transform duration-300 shadow-lg flex-shrink-0">
                                <img
                                  src={locationIcon}
                                  alt=""
                                  className="w-5 h-5 filter brightness-0 invert"
                                />
                              </div>
                              <div className="flex-1 min-w-0">
                                <div className="text-slate-300 font-semibold text-base mb-1">
                                  {content[e]}
                                </div>
                                <div className="space-y-1">
                                  {content[e + "_"]
                                    ?.split(".")
                                    ?.filter((s) => s.trim())
                                    .map((s, i) => (
                                      <div
                                        className="text-slate-400 text-xs leading-tight"
                                        key={i}
                                      >
                                        {s.trim()}
                                      </div>
                                    ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </Col>

                  {/* نموذج الاتصال */}
                  <Col md={6} className="space-y-6">
                    <div className="bg-slate-700/60 rounded-2xl p-6 border border-slate-600/50 backdrop-blur-sm">
                      <div className="space-y-3">
                        <div className="flex gap-2">
                          {/* الاسم */}
                          <div className="w-full">
                            <label className="block text-slate-200 font-medium mb-2">
                              {content.name}:
                            </label>
                            <input
                              onChange={handleChange}
                              value={formData.name}
                              name="name"
                              type="text"
                              className="w-full px-4 py-3 border border-slate-600/50 rounded-xl focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-slate-400 transition-all duration-300 bg-slate-600/30 text-white placeholder-slate-400"
                            />
                          </div>

                          {/* رقم الهاتف */}
                          <div className="w-full">
                            <label className="block text-slate-200 font-medium mb-2">
                              {content.phone_number}:
                            </label>
                            <input
                              onChange={handleChange}
                              value={formData.phone}
                              name="phone"
                              type="text"
                              className="w-full px-4 py-3 border border-slate-600/50 rounded-xl focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-slate-400 transition-all duration-300 bg-slate-600/30 text-white placeholder-slate-400"
                            />
                          </div>
                        </div>

                        {/* البريد الإلكتروني */}
                        <div>
                          <label className="block text-slate-200 font-medium mb-2">
                            {content.email}:
                          </label>
                          <input
                            onChange={handleChange}
                            value={formData.email}
                            name="email"
                            type="email"
                            className="w-full px-4 py-3 border border-slate-600/50 rounded-xl focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-slate-400 transition-all duration-300 bg-slate-600/30 text-white placeholder-slate-400"
                          />
                        </div>

                        {/* المنتج المهتم به */}
                        <div>
                          <label className="block text-slate-200 font-medium mb-2">
                            {content.product_you_are_interested}:
                          </label>
                          <select
                            onChange={handleChange}
                            value={formData.product}
                            name="product"
                            className="w-full px-4 py-3 border border-slate-600/50 rounded-xl focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-slate-400 transition-all duration-300 bg-slate-600/30 text-white"
                          >
                            <option
                              value=""
                              hidden
                              className="text-slate-800"
                            ></option>
                            {[1, 2, 3, 4, 5, 6, 7].map((e) => (
                              <option
                                key={e}
                                value={content["products_" + e]}
                                className="text-slate-800"
                              >
                                {content["products_" + e]}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* زر الإرسال */}
                        <button
                          onClick={handleSubmit}
                          className="w-full bg-gradient-to-r from-slate-600 to-slate-500 hover:from-slate-500 hover:to-slate-400 text-white py-4 rounded-xl font-semibold hover:shadow-xl transform hover:scale-105 transition-all duration-300 shadow-lg shadow-slate-600/25 flex items-center justify-center gap-2"
                        >
                          <span>{content.inquiry_send}</span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-5 h-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </Col>
                </Row>

                {/* الروابط السريعة */}
                <div className="mt-2">
                  <div className="flex justify-center items-center flex-wrap gap-6">
                    {ContactList.map((e, i) => (
                      <a
                        key={i}
                        href={e.link ? e.link : "https://wa.me/+971504681550"}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group relative"
                      >
                        <div className="absolute -inset-2 bg-gradient-to-r from-slate-600 to-slate-500 rounded-2xl blur opacity-0 group-hover:opacity-30 transition duration-500"></div>
                        <div className="relative w-16 h-16 bg-slate-700/50 rounded-2xl flex items-center justify-center shadow-lg hover:shadow-xl transform hover:scale-110 hover:-translate-y-1 transition-all duration-300 border border-slate-600/50 backdrop-blur-sm">
                          <img
                            src={e.image}
                            alt="contact_us"
                            className="w-8 h-8"
                          />
                        </div>
                      </a>
                    ))}
                  </div>
                </div>

                {/* حقوق النشر */}
                <div className="text-center mt-5 pt-5 border-t border-slate-600/50">
                  <div className="text-slate-400 text-sm mb-1">
                    {localStorage.getItem("language") === "ar"
                      ? "جميع الحقوق محفوظة لشركة سكاي سيتي للاعلانات الامارات العربية المتحدة"
                      : "sall Right Reserve to sky city advertisement Co.United Arab Emirates"}
                  </div>
                  <div className="text-slate-300 font-medium">
                    <Link
                      to="/privacy-policy"
                      className="hover:text-slate-200 transition-colors duration-300"
                    >
                      Privacy Policy
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>

      {/* إضافة الأنيميشن المخصصة في CSS */}
      {swiperIndex === 5 && (
        <style jsx>{`
          @keyframes float-slow {
            0%,
            100% {
              transform: translate(0, 0) scale(1);
              opacity: 0.2;
            }
            33% {
              transform: translate(30px, -20px) scale(1.1);
              opacity: 0.3;
            }
            66% {
              transform: translate(-20px, 15px) scale(1.05);
              opacity: 0.25;
            }
          }
          @keyframes pulse-soft {
            0%,
            100% {
              opacity: 0.1;
              transform: scale(1);
            }
            50% {
              opacity: 0.2;
              transform: scale(1.05);
            }
          }
          @keyframes scan-vertical {
            0% {
              transform: translateX(-100%);
            }
            100% {
              transform: translateX(100%);
            }
          }
          @keyframes drift {
            0%,
            100% {
              transform: translate(0, 0) rotate(0deg);
              opacity: 0.3;
            }
            25% {
              transform: translate(10px, -15px) rotate(90deg);
              opacity: 0.6;
            }
            50% {
              transform: translate(-5px, -25px) rotate(180deg);
              opacity: 0.4;
            }
            75% {
              transform: translate(15px, -10px) rotate(270deg);
              opacity: 0.7;
            }
          }
          @keyframes grid-move {
            0% {
              background-position: 0 0;
            }
            100% {
              background-position: 30px 30px;
            }
          }
          .animate-float-slow {
            animation: float-slow 25s ease-in-out infinite;
          }
          .animate-pulse-soft {
            animation: pulse-soft 10s ease-in-out infinite;
          }
          .animate-scan-vertical {
            animation: scan-vertical 6s linear infinite;
          }
          .animate-drift {
            animation: drift 25s ease-in-out infinite;
          }
          .animate-grid-move {
            animation: grid-move 20s linear infinite;
          }
          .animation-delay-3000 {
            animation-delay: 3s;
          }
        `}</style>
      )}
    </div>
  );
};

export default ContactUs;
